import * as React from "react";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";
import Stacked from "./Layouts/Stacked";
import Overlayed from "./Layouts/Overlayed";
import { useState } from "react";

const Layouts = {
  default: Overlayed,
  stacked_text_below: Stacked,
  stacked_text_above: Stacked
};

export const Tile = ({
  data,
  layout = "default",
  height,
  settings,
}) => {
  const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);
  const [isHovered, setIsHovered] = useState(false);
  
  // Get hover effect settings
  const enableHoverEffect = data?.settings?.enable_hover_effect;

  const LayoutComponent = Layouts[layout] || Layouts.default;

  // Add hover class if the feature is enabled

  const columnHeight = isMobile
    ? data.settings.mobile_block_height
    : data.settings.block_height;

  return (
    <div 
      className={`${enableHoverEffect ? 'hover-effect' : ''} ${columnHeight === 0 && data.settings.full_height_column === true ? "h-full" : ""} ${data.settings.custom_classes}`}
    >
      <LayoutComponent 
        data={data} 
        height={height} 
        settings={settings} 
        isMobile={isMobile}
      />
    </div>
  );
};

export default Tile;
